import { Component, OnInit } from '@angular/core';
import { BookingService } from '../../landing/services/booking.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { RaterequestStatus ,RateStatus} from 'src/app/Enum/Enum';
import { RateRequestService } from 'src/app/core-services/raterequest.services';
import { ViewBookingVM } from 'src/app/models/ViewBookingVM';


@Component({
  selector: 'app-booking-detailslist',
  templateUrl: './booking-detailslist.component.html',
  styleUrls: ['./booking-detailslist.component.scss'],
  providers: [ConfirmationService]
})
export class BookingDetailslistComponent implements OnInit {
  currentUser: any;
  bookinglist: any;
  pageSize: number;
  totalcount:number;
  currentPage:number;
  SerachField:string="";
  bookingstatus:any;  
  frmport:string;
  toport:string;
  freightratedropdown:any=[];
  ratedropdown: any = [];
  selectedCafname:string;
  selectedBAFname:string;        
  selectedRatename:string;
  selectedThcname:string;
  selectedOtherchargesname:string;
  bookingdetails:any;
  options:string[];
  selectrateStatus:any;
  myValue = RateStatus;
  contactName :string;
  contactEmail: string;
  phoneNumber:string;
  RateStatus : typeof RateStatus = RateStatus;
   status:number=0;
  constructor(private bookingservice: BookingService,
    private raterequestservice: RateRequestService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService) {
      this.raterequestservice.getRateRequestDropdown().subscribe(data => this.ratedropdown.push(...data)); 
      this.bookingdetails = new ViewBookingVM();
  }

  ngOnInit() {
    this.currentUser = JSON.parse(String(localStorage.getItem('currentUser')));
    this.pageSize = 10;    
    this.currentPage= 1;
    this.GetBookingList();
    this.bookingstatus = RateStatus;
    var x = RateStatus;
    var options = Object.keys(RateStatus);
    this.options = options.slice(options.length / 2);
    this.selectrateStatus =options[3];
  }

  GetBookingList() {
    let userid = this.currentUser.usersDetailsVM.userId;
    this.spinner.show();
    this.bookingservice.GetBookingList(userid,this.currentPage,this.pageSize,this.SerachField,this.status).subscribe((response: any) => {
      if (response.result != null && response.result.isSuccess == true && response.result.content != null) {
        this.bookinglist = response.result.content.content;             
        this.totalcount = response.result.content.totalCount;
        this.spinner.hide();
        // this.router.navigate(['/login']);                   
        
        // this.router.navigate(['/raterequestlist']);
        // this.toastr.success('Rate Request Has been Send Sucessfully..!', '');
      }
      this.spinner.hide();
    })
   // this.spinner.hide();
  }

  statusValue(value : string) {
    this.myValue = RateStatus[value];
    if (this.selectrateStatus != null && this.selectrateStatus != undefined && this.selectrateStatus.length > 0) {
      this.currentPage = 1;
      this.pageSize = 10;
     this.status= parseInt(RateStatus[ this.selectrateStatus]);
      
    }
    else {
      this.currentPage = 1;
      this.pageSize = 10;
      this.status =parseInt(RateStatus [ this.selectrateStatus]);
    }
    this.GetBookingList();
  }

  CancelBooking(id) {
    this.confirmationService.confirm({
      header:'Cancel booking !',
      message: 'Are you sure to cancel this booking ?',
      accept: () => {
        this.bookingservice.CancelBooking(id).subscribe((response: any) => {
          if (response != null && response.isSuccess == true && response.content != null) {
            this.GetBookingList();
            this.toastr.success('Booking Cancelled Sucessfully.');           
          }
          else {
            this.toastr.warning('You Can not Delete This Booking.');
          }
        })
      }
    });
  }

  paginate(event) {
    this.currentPage = event.page + 1;
    this.pageSize = event.rows;
    this.GetBookingList();
  }

  filterSearch(msg){    
    this.SerachField = msg;
    this.GetBookingList();
  }

  ConfirmedBooking(id) {
    this.confirmationService.confirm({
      header:'Confirm Booking !',
      message: 'Are you sure to confirm this booking?',
      accept: () => {
        this.spinner.show()
        this.bookingservice.ConfirmedBooking(id).subscribe((response: any) => {       
          if (response.result != null && response.result.isSuccess == true && response.result.content != null) {
            this.spinner.hide();
            this.GetBookingList();
            this.toastr.success('Booking Confirmed .');           
          }
          else {
            this.spinner.hide();
            this.toastr.warning('Something went Wrong.');
          }
        })        
      }
    });
  }

  GetBookingDetails(raterequestid,frmport,toport,offerdrateId)
  {            
    this.frmport = frmport;    
    this.toport = toport;           
    this.raterequestservice.Getofferedratedet(raterequestid,offerdrateId).subscribe((response: any) => {
      if (response != null && response.isSuccess == true && response.content != null) {
        this.contactName = response.content.firstName + ' ' + response.content.lastName;
        this.contactEmail = response.content.email;
        this.phoneNumber = response.content.phoneNumber;
        let newDate =  new Date(response.content.freightRateValidity);
        var selectedBAF = this.ratedropdown.filter(x => x.value == response.content.rateBasisBAF);
        var selectedRate = this.ratedropdown.filter(x => x.value == response.content.rateBasisFreightRate);
        var selectedCaf = this.ratedropdown.filter(x => x.value == response.content.rateBasisCAF);
        var selectedThc = this.ratedropdown.filter(x => x.value == response.content.rateBasisTHC);
        var selectedOthercharges = this.ratedropdown.filter(x => x.value == response.content.rateBasisOtherChareges);
        this.selectedCafname = selectedCaf[0].label;
        this.selectedBAFname = selectedBAF[0].label;        
        this.selectedRatename = selectedRate[0].label;
        this.selectedThcname = selectedThc[0].label;
        this.selectedOtherchargesname = selectedOthercharges[0].label;
        // this.offeredRateReason = response.content.reasonForReRequest;
        this.bookingdetails = response.content;
        // for (var property in response.content) {
        //   if (response.content.hasOwnProperty(property) && this.bookingdetails.hasOwnProperty(property)) {
        //     this.bookingdetails[property] = response.content[property];
      
        //   }
        // }
       
        // this.RateForm = this.fb.group({
        //   noOfUnits: [response.content.totalNumberOfUnits],
        //   totallanemeters: [response.content.totalLandMeter],
        //   totalCubicmeters: [response.content.totalCubicMeter],
        //   freightrate: [response.content.freightRate],
        //   freightratebasis: [selectedRate[0].value],
        //   othercharges: [response.content.otherCharges],
        //   otherchargesbasis: [selectedOthercharges[0].value],
        //   baf: [response.content.baf],
        //   bafbasis: [selectedBAF[0].value],
        //   caf: [response.content.caf],
        //   cafbasis: [selectedCaf[0].value],
        //   thc: [response.content.thc],
        //   thcbasis: [selectedThc[0].value],
        //   totalsumofallcost: [response.content.totalFreightCost],
        //   costperunit: [response.content.costPerUnit],
        //   costpercubicmeter: [response.content.costPerCubicMeter],
        //   freightratevalidity: [newDate],  
        //   ratetotal: [response.content.ratetotal],  
        //   baftotal: [response.content.baftotal],          
        //   caftotal:[response.content.caftotal],
        //   thctotal:[response.content.thctotal],
        //   otherchargestotal:[response.content.otherchargestotal]
        // });			
        // this.offeredamount = parseFloat(response.content.totalFreightCost.toFixed(0.00));        
      }
      else {
        this.toastr.error('Something went wrong!', 'Oops!!');
      }
    });
  }
  
  // document.paypal.Buttons({
  //   createOrder: function(data, actions) {
  //     // This function sets up the details of the transaction, including the amount and line item details.
  //     return actions.order.create({
  //       purchase_units: [{
  //         amount: {
  //           value: '0.01'
  //         }
  //       }]
  //     });
  //   }
  // }).render('#paypal-button-container');
}
